module.exports = __webpack_public_path__ + "img/组 8@2x.c069f8a0.png";